import { useState } from "react";
import { Box, Container, Typography, Card, CardActionArea, CardContent, Chip } from "@mui/material";
import BedIcon from "@mui/icons-material/Bed";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import ShowerIcon from "@mui/icons-material/Shower";
import HotelIcon from "@mui/icons-material/Hotel";
import SectionTitle from "../components/SectionTitle";

const CATEGORIES = [
  { id: "all", label: "Tout" },
  { id: "Draps", label: "Draps" },
  { id: "Serviettes de bain", label: "Serviettes Bain" },
  { id: "Serviettes de table", label: "Serviettes Table" },
  { id: "Nappes", label: "Nappes" },
  { id: "Taies d'oreiller", label: "Taies" },
  { id: "Literie", label: "Literie" },
  { id: "Bain", label: "Bain" },
];

const CATALOGUE_ITEMS = [
  { id: "LL-001", name: "Serviette de Table", category: "Serviettes de table", note: "55 x 55 cm — 100% Coton", icon: TableRestaurantIcon },
  { id: "LL-002", name: "Serviette de Table", category: "Serviettes de table", note: "50 x 70 cm — 100% Coton", icon: TableRestaurantIcon },
  { id: "LL-004", name: "Serviette de Visage", category: "Serviettes de bain", note: "50 x 90 cm — 100% Coton", icon: ShowerIcon },
  { id: "LL-005", name: "Serviette Visage", category: "Serviettes de bain", note: "20 x 20 cm — 100% Coton", icon: ShowerIcon },
  { id: "LL-006", name: "Serviette de Corps", category: "Serviettes de bain", note: "150 x 90 cm — 100% Coton", icon: ShowerIcon },
  { id: "LL-007", name: "Peignoir", category: "Serviettes de bain", note: "Coupe confort — 100% Coton", icon: CheckroomIcon },
  { id: "LL-008", name: "Drap Plat", category: "Draps", note: "150 x 270 cm — 100% Coton", icon: BedIcon },
  { id: "LL-009", name: "Drap Plat", category: "Draps", note: "290 x 300 cm — 100% Coton", icon: BedIcon },
  { id: "LL-010", name: "Taie", category: "Taies d'oreiller", note: "70 x 40 cm — 100% Coton", icon: HotelIcon },
  { id: "LL-011", name: "Housse de Couette", category: "Literie", note: "170 x 250 cm — 100% Coton", icon: BedIcon },
  { id: "LL-012", name: "Housse de Couette", category: "Literie", note: "250 x 270 cm — 100% Coton", icon: BedIcon },
  { id: "LL-013", name: "Tapis de Bain", category: "Bain", note: "50 x 90 cm — 100% Coton", icon: ShowerIcon },
  { id: "LL-014", name: "Tapis de Bain", category: "Bain", note: "50 x 80 cm — 100% Coton", icon: ShowerIcon },
  { id: "LL-015", name: "Nappe Ronde PM", category: "Nappes", note: "Petite ronde — pour tables de restaurant", icon: TableRestaurantIcon },
  { id: "LL-016", name: "Nappe Ronde GM", category: "Nappes", note: "Grande ronde — pour banquets et événements", icon: TableRestaurantIcon },
  { id: "LL-017", name: "Nappe Carrée PM", category: "Nappes", note: "Petite carrée — format bistrot", icon: TableRestaurantIcon },
  { id: "LL-018", name: "Nappe Carrée GM", category: "Nappes", note: "Grande carrée — pour grandes tables", icon: TableRestaurantIcon },
];

const PARTNERS = [
  { slug: "kiproglou", name: "Kiproglou", url: "https://kirpoglou.gr/en/" },
  { slug: "deren", name: "Deren", url: "https://deren.fr/" },
];

const HeroBanner = () => (
  <Box sx={{
    position: "relative", height: { xs: "60vh", md: "80vh" },
    display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", overflow: "hidden",
    background: 'url("/images/linens.jpg") center/cover no-repeat',
    "&::before": { content: '""', position: "absolute", inset: 0, background: "linear-gradient(to bottom, rgba(10,6,2,0.6) 0%, rgba(10,6,2,0.4) 50%, rgba(10,6,2,0.85) 100%)", zIndex: 1 },
  }}>
    <Container maxWidth="md" sx={{ position: "relative", zIndex: 2, px: { xs: 2, md: 3 } }}>
      <Typography sx={{ color: "secondary.main", fontSize: "0.68rem", letterSpacing: "0.3em", textTransform: "uppercase", fontWeight: 700, mb: 1.5 }}>Services</Typography>
      <Typography variant="h1" sx={{ color: "#fff", fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: { xs: "1.6rem", md: "3rem" }, mb: 2, lineHeight: 1.1 }}>Location & Vente de Linge</Typography>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, mb: 2.5 }}>
        <Box sx={{ width: 50, height: "1px", backgroundColor: "rgba(201,168,76,0.5)" }} />
        <Box sx={{ width: 5, height: 5, backgroundColor: "secondary.main", transform: "rotate(45deg)" }} />
        <Box sx={{ width: 50, height: "1px", backgroundColor: "rgba(201,168,76,0.5)" }} />
      </Box>
      <Typography sx={{ color: "rgba(255,255,255,0.7)", fontSize: { xs: "0.85rem", md: "1rem" }, lineHeight: 1.8, maxWidth: 520, mx: "auto" }}>
        Linge de haute qualité pour hôtels, riads et restaurants — location, vente, lavage et remplacement inclus.
      </Typography>
    </Container>
    <Box sx={{ position: "absolute", bottom: -1, left: 0, right: 0, zIndex: 3, lineHeight: 0 }}>
      <svg viewBox="0 0 1440 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: "block", width: "100%", height: 50 }}>
        <path d="M0,30 C360,55 1080,5 1440,30 L1440,50 L0,50 Z" fill="#f5f0e8" />
      </svg>
    </Box>
  </Box>
);

/* ── Catalogue Card — shows photo if it exists, icon fallback ── */
const CatalogueCard = ({ id, name, category, note, icon: Icon }) => (
  <Card sx={{
    backgroundColor: "#fff", border: "1px solid rgba(201,168,76,0.2)", borderRadius: "10px",
    height: "100%", boxShadow: "0 2px 16px rgba(26,17,8,0.07)", transition: "all 0.3s ease",
    "&:hover": { transform: "translateY(-5px)", boxShadow: "0 14px 40px rgba(26,17,8,0.14)", borderColor: "secondary.main", "& .cat-icon": { color: "secondary.main" } },
  }}>
    <CardActionArea sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}>

      {/* ── Image area ── */}
      <Box sx={{
        height: 160,
        position: "relative",
        borderRadius: "10px 10px 0 0",
        overflow: "hidden",
        backgroundColor: "#1c1208",
      }}>
        {/* Real photo — place file at public/images/catalogue/LL-001.jpg */}
        <Box
          component="img"
          src={`/images/catalogue/${id}.jpg`}
          alt={name}
          onError={(e) => {
            // Hide broken image, show icon fallback
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            display: "block",
            transition: "transform 0.4s ease",
            ".MuiCardActionArea-root:hover &": { transform: "scale(1.05)" },
          }}
        />

        {/* Icon fallback — shown when no image */}
        <Box sx={{
          display: "none", // shown via onError
          position: "absolute", inset: 0,
          alignItems: "center", justifyContent: "center",
          background: "radial-gradient(ellipse at center, rgba(201,168,76,0.12) 0%, transparent 70%)",
        }}>
          <Icon className="cat-icon" sx={{ fontSize: 48, color: "rgba(201,168,76,0.7)", transition: "color 0.3s ease" }} />
        </Box>

        {/* ID badge */}
        <Typography sx={{
          position: "absolute", bottom: 6, right: 8,
          color: "rgba(201,168,76,0.6)", fontSize: "0.58rem",
          letterSpacing: "0.12em", fontFamily: "monospace",
          zIndex: 2,
          // visible on both photo and icon
          textShadow: "0 1px 4px rgba(0,0,0,0.5)",
        }}>
          {id}
        </Typography>
      </Box>

      <CardContent sx={{ p: { xs: 2, md: 2.5 }, flexGrow: 1, display: "flex", flexDirection: "column", gap: 0.8 }}>
        <Chip label={category} size="small" sx={{ alignSelf: "flex-start", backgroundColor: "rgba(201,168,76,0.1)", color: "secondary.dark", fontSize: "0.58rem", letterSpacing: "0.1em", fontWeight: 700, textTransform: "uppercase", borderRadius: "3px", height: 18 }} />
        <Typography sx={{ color: "text.primary", fontFamily: "'Playfair Display', serif", fontWeight: 600, fontSize: { xs: "0.88rem", md: "0.98rem" }, lineHeight: 1.3 }}>{name}</Typography>
        <Typography sx={{ color: "text.secondary", fontSize: { xs: "0.72rem", md: "0.78rem" }, lineHeight: 1.5, mt: "auto" }}>{note}</Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);

const LocationLingePage = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  const filtered = activeCategory === "all" ? CATALOGUE_ITEMS : CATALOGUE_ITEMS.filter(item => item.category === activeCategory);

  return (
    <Box>
      <HeroBanner />
      <Box sx={{ position: "relative", backgroundColor: "#f5f0e8", "&::before": { content: '""', position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none", background: 'url("/images/flowers.jpg") center/cover no-repeat', opacity: 0.03 } }}>
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Box sx={{ pt: { xs: 5, md: 8 }, pb: { xs: 5, md: 8 } }}>
            <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
              <SectionTitle overline={`${CATALOGUE_ITEMS.length} articles disponibles`} title="Catalogue" align="center" />

              {/* Category filter */}
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "center", mb: { xs: 4, md: 6 } }}>
                {CATEGORIES.map((cat) => (
                  <Box key={cat.id} onClick={() => setActiveCategory(cat.id)} sx={{
                    px: { xs: 1.5, md: 3 }, py: { xs: 0.7, md: 1 },
                    cursor: "pointer", border: "1px solid",
                    borderColor: activeCategory === cat.id ? "secondary.main" : "rgba(201,168,76,0.25)",
                    backgroundColor: activeCategory === cat.id ? "secondary.main" : "transparent",
                    borderRadius: "2px", transition: "all 0.25s ease",
                    "&:hover": { borderColor: "secondary.main" },
                  }}>
                    <Typography sx={{ fontSize: { xs: "0.65rem", md: "0.75rem" }, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", color: activeCategory === cat.id ? "#1a0f05" : "text.secondary", transition: "color 0.25s ease" }}>
                      {cat.label}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Cards — 2 cols mobile, 3 cols desktop */}
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: { xs: 2, md: 3 } }}>
                {filtered.map((item) => (
                  <Box key={item.id} sx={{
                    flex: { xs: "1 1 calc(50% - 8px)", md: "1 1 calc(33.333% - 24px)" },
                    maxWidth: { xs: "calc(50% - 8px)", md: "calc(33.333% - 24px)" },
                    minWidth: { xs: "140px", md: "220px" },
                  }}>
                    <CatalogueCard {...item} />
                  </Box>
                ))}
              </Box>
            </Container>
          </Box>

          {/* Partners */}
          <Box sx={{ py: { xs: 6, md: 10 }, borderTop: "1px solid rgba(201,168,76,0.15)" }}>
            <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
              <SectionTitle overline="Ils nous font confiance" title="Nos Partenaires" align="center" />
              <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: { xs: 2, md: 4 } }}>
                {PARTNERS.map(({ slug, name, url }) => (
                  <Box key={slug} component="a" href={url} target="_blank" rel="noopener noreferrer" sx={{
                    width: { xs: 140, md: 200 }, height: { xs: 85, md: 110 },
                    backgroundColor: "#fff", border: "1px solid rgba(201,168,76,0.2)", borderRadius: "8px",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    textDecoration: "none", overflow: "hidden",
                    boxShadow: "0 2px 12px rgba(26,17,8,0.06)", transition: "all 0.3s ease",
                    "&:hover": { borderColor: "secondary.main", boxShadow: "0 8px 28px rgba(201,168,76,0.2)", transform: "translateY(-4px)" },
                  }}>
                    <Box component="img" src={`/images/partenaires/${slug}.png`} alt={name}
                      onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                      sx={{ maxWidth: "75%", maxHeight: "65%", objectFit: "contain" }}
                    />
                    <Box sx={{ display: "none", width: "100%", height: "100%", alignItems: "center", justifyContent: "center" }}>
                      <Typography sx={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: { xs: "0.85rem", md: "1rem" }, color: "text.primary", textAlign: "center", px: 1 }}>{name}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Container>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LocationLingePage;